import { render, staticRenderFns } from "./XLabelGroupTrigger.vue?vue&type=template&id=d34761be"
import script from "./XLabelGroupTrigger.vue?vue&type=script&lang=js"
export * from "./XLabelGroupTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports